/**
 * **Message crew** (the header, Boards 1 – 14) and the phone's green **Add
 * note** — `docs/visit-page.md` §7.9: "Opens the For the crew composer
 * (§13.3) in a sheet with *This visit* and **Tell the crew now** on."
 *
 * The composer is For the crew's own (`crew-note-composer.tsx`); this is only
 * the box around it — Slice 6's `VisitCard` at the right edge on a desktop,
 * Board 16 D's sheet from the bottom on a phone. Its homes come from the
 * page's read: the visit's property, and the job's contact by first name.
 */
import { firstNameOf, type CrewNoteComposer, type VisitRead } from '@rowted/shared'
import { usePhone } from '../lib/use-narrow.js'
import { VisitCard, VisitTile } from './sheet.js'
import { useVisitWrite, type VisitWriteResult } from './api.js'
import { CrewNoteComposerCard } from './crew-note-composer.js'
import { CREW_NOTE } from './copy.js'

export function CrewNoteSheet({
  visitId, read, onClose, onWritten, tab = 'overview',
}: {
  visitId: string
  read: VisitRead
  onClose: () => void
  onWritten?: (result: VisitWriteResult) => void
  /** The tab it was opened over — its fresh read comes back with the write. */
  tab?: 'overview' | 'for-crew'
}) {
  const phone = usePhone()
  const write = useVisitWrite(visitId)
  const { property, contact } = read.header.meta
  const composer: CrewNoteComposer = {
    can: read.can.edit,
    property: property ? { id: property.id, line1: property.line1 } : null,
    contact: contact ? { id: contact.id, firstName: firstNameOf(contact.name) } : null,
    tellCrewNow: true,
  }
  return (
    <VisitCard
      width={560}
      title={CREW_NOTE.title}
      sub={CREW_NOTE.sub}
      mark={<VisitTile glyph="clipboard" tone="teal" size={36} />}
      onClose={onClose}
    >
      <CrewNoteComposerCard
        composer={composer}
        orgUnitId={read.orgUnitId}
        write={write}
        tab={tab}
        phone={phone}
        variant="sheet"
        onWritten={(result) => { onWritten?.(result); onClose() }}
      />
    </VisitCard>
  )
}
